import { render, staticRenderFns } from "./AddChild.vue?vue&type=template&id=c0890600&scoped=true"
import script from "./AddChild.vue?vue&type=script&lang=js"
export * from "./AddChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0890600",
  null
  
)

export default component.exports